var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginCloudPasqua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 664.48 483.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ba6c6c;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #909baa;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #55468c;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #d9e3ed;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #297dc1;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #bdc6d1;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #729ab2;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #f2b8c4;\r\n      }\r\n\r\n      .cls-14 {\r\n        stroke-width: 4.57px;\r\n      }\r\n\r\n      .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-20, .cls-21, .cls-22 {\r\n        stroke: #869da8;\r\n      }\r\n\r\n      .cls-15 {\r\n        stroke-width: 2.16px;\r\n      }\r\n\r\n      .cls-16 {\r\n        stroke-width: 1.85px;\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: #297bc0;\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: #7f7d89;\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: #fffffb;\r\n      }\r\n\r\n      .cls-17 {\r\n        stroke-width: 3.66px;\r\n      }\r\n\r\n      .cls-18 {\r\n        stroke-width: 3.2px;\r\n      }\r\n\r\n      .cls-19 {\r\n        stroke: #297dc1;\r\n        stroke-width: 14px;\r\n      }\r\n\r\n      .cls-20 {\r\n        stroke-width: 2.47px;\r\n      }\r\n\r\n      .cls-21 {\r\n        stroke-width: 4px;\r\n      }\r\n\r\n      .cls-12 {\r\n        fill: #bc2b2b;\r\n      }\r\n\r\n      .cls-22 {\r\n        stroke-width: 1.62px;\r\n      }\r\n\r\n      .cls-13 {\r\n        fill: #0b6db5;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "coniglio"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dritto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m559.05,176.32c-4.43-.84-8.86-1.67-13.29-2.51-3.89-47.33,8.23-78.06,17.16-94.73.96-1.8,18.85-34.77,28.11-31.78,9.29,3,4.51,40.42,4,44.21-2.61,19.58-10.35,50.12-35.99,84.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m550.19,171.57c2.09.4,4.19.8,6.28,1.2,10.87-17.03,17.59-32.57,21.81-44.3,1.6-4.44,7.05-20.04,10.19-41.27,1.76-11.89,4.42-29.94.17-31.42-5.24-1.84-18.05,22.59-19.51,25.38-3.23,6.16-10.74,21.52-15.37,44.55-2.24,11.17-4.35,26.87-3.58,45.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Storto"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m577.55,187.37c-4-2.46-8-4.92-11.99-7.39,12.32-30.3,26.27-52.36,36.73-66.88,10.25-14.24,23.65-32.85,31.29-30.05,8.88,3.26,5.18,33.71,4.28,40.58-20.1,21.25-40.2,42.49-60.3,63.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m570.71,179.45c1.89,1.17,3.78,2.34,5.67,3.5,12.78-14.68,26.25-29.58,40.42-44.64,9.9-10.52,19.75-20.69,29.51-30.52-1.84-7.08-3.68-14.15-5.52-21.23-.97.22-2.48.61-4.26,1.27-9.07,3.41-14.35,10.1-16.97,13.52-19.57,25.46-29.36,38.18-36.95,52.66-3.07,5.85-7.37,14.51-11.9,25.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m639.07,136.59c-4-1.63-2.18-12.02-5.01-35.75-.93-7.79-2.01-14.07-2.72-17.94,1.84-.14,4.56-.13,7.67.66,8.87,2.27,13.72,9.13,15.66,11.89,5.73,8.12,6.24,16.59,6.24,20.15-13.63,19.57-19.22,22.06-21.84,20.99Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Nuvola"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sfondo",
    className: "cls-11",
    d: "m657.48,273.87c0-54.46-44.13-98.59-98.59-98.59-7.58,0-14.94.89-22.01,2.5,1.3-6.76,2-13.75,2-20.9,0-60.98-49.43-110.41-110.41-110.41-32.62,0-61.92,14.15-82.12,36.64C325.16,38.14,279.43,7,226.43,7c-73.17,0-132.5,59.33-132.5,132.51,0,12.5,1.77,24.57,5.01,36.04-51.35,3.43-91.95,46.13-91.95,98.35s44.15,98.59,98.59,98.59h474.17c46.29-8.12,77.72-49.99,77.72-98.59v-.03Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sinapsi_4",
    "data-name": "Sinapsi 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m8.38,281.54c12.15-.25,24.31-.5,36.46-.75l39.04-7.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m7,274.37c11.7-.21,23.4-.42,35.1-.64l14.38-12.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m8.18,288.69c11.34-.23,22.68-.47,34.03-.7l15.1,14.73"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 92.33,
    cy: 271.04,
    r: 8.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 63.56,
    cy: 251.26,
    r: 12.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 67.87,
    cy: 312.04,
    r: 14.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m70.26,246.74c2.47,3.74,1.43,8.76-2.31,11.22s-8.76,1.43-11.22-2.31c-2.47-3.74-1.43-8.76,2.31-11.22,3.74-2.47,8.76-1.43,11.22,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m96.74,268.15c1.6,2.43.94,5.72-1.51,7.32-2.43,1.6-5.7.94-7.32-1.51-1.6-2.43-.94-5.7,1.5-7.32,2.43-1.6,5.72-.94,7.32,1.51h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m76.69,306.23c3.22,4.87,1.86,11.42-3.01,14.62-4.87,3.22-11.42,1.86-14.62-3.01-3.22-4.87-1.86-11.42,3.01-14.64,4.87-3.22,11.42-1.86,14.64,3.01l-.02.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sinapsi_3",
    "data-name": "Sinapsi 3"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "644.96 225.76 609.54 245.6 568.29 281.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "648.56 233.88 615.96 252.32 607.49 276.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-15",
    points: "639.16 216.61 606.34 235.93 579.09 228.67"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 559.66,
    cy: 288.8,
    r: 11.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 606.43,
    cy: 292.56,
    r: 16.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 560.71,
    cy: 225.16,
    r: 18.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m601.33,302.25c-5.32-2.68-7.48-9.18-4.78-14.5,2.68-5.32,9.18-7.46,14.5-4.78s7.48,9.18,4.78,14.5c-2.68,5.32-9.18,7.48-14.5,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m556.49,295.08c-3.48-1.76-4.87-5.98-3.11-9.46,1.76-3.48,5.98-4.87,9.46-3.11,3.48,1.76,4.87,5.98,3.13,9.46-1.76,3.48-5.98,4.87-9.46,3.13l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m554.37,237.74c-6.96-3.49-9.74-11.96-6.24-18.92,3.49-6.96,11.96-9.74,18.92-6.24,6.96,3.49,9.74,11.96,6.24,18.92-3.49,6.96-11.96,9.74-18.92,6.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sinapsi_2",
    "data-name": "Sinapsi 2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "408.62 372.49 408.28 316.69 394.02 236.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "394.27 372.49 394.84 319.72 371.08 290.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-18",
    points: "422.57 372.49 422.99 320.02 452.23 291.64"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 351.11,
    cy: 276.62,
    r: 24.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 391.41,
    cy: 220.23,
    r: 16.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 471.46,
    cy: 270.23,
    r: 27.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m342.57,263.11c7.46-4.73,17.35-2.5,22.07,4.97,4.71,7.46,2.5,17.35-4.97,22.07-7.46,4.73-17.35,2.5-22.07-4.97-4.73-7.48-2.5-17.35,4.97-22.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m385.83,211.6c4.87-3.08,11.32-1.63,14.4,3.25,3.08,4.87,1.63,11.32-3.23,14.4s-11.32,1.63-14.4-3.23c-3.08-4.87-1.63-11.32,3.25-14.4l-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m460.32,252.6c9.74-6.16,22.62-3.25,28.78,6.49,6.16,9.74,3.25,22.62-6.49,28.78-9.74,6.16-22.62,3.25-28.78-6.49-6.16-9.74-3.25-22.62,6.49-28.79v.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sinapsi_1",
    "data-name": "Sinapsi 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "109.03 78.04 171.14 116.79 264.96 155.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "118.13 63.16 176.93 100.55 223.3 94.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "107.38 97.66 157.8 130.11 168.24 179.96"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 251.92,
    cy: 83.16,
    r: 30.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 284.07,
    cy: 163.68,
    r: 20.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 178.01,
    cy: 214.58,
    r: 34.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 251.66,
    cy: 83.16,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 284.13,
    cy: 163.28,
    r: 13.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 178.01,
    cy: 214.58,
    r: 26.08
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bordo"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m657.48,273.87c0-54.46-44.13-98.59-98.59-98.59-7.58,0-14.94.89-22.01,2.5,1.3-6.76,2-13.75,2-20.9,0-60.98-49.43-110.41-110.41-110.41-32.62,0-61.92,14.15-82.12,36.64C325.16,38.14,279.43,7,226.43,7c-73.17,0-132.5,59.33-132.5,132.51,0,12.5,1.77,24.57,5.01,36.04-51.35,3.43-91.95,46.13-91.95,98.35s44.15,98.59,98.59,98.59h474.17c46.29-8.12,77.72-49.99,77.72-98.59v-.03Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Scritta"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Control"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m338.9,432.56c-.56,5.9-2.75,10.51-6.58,13.81s-8.91,4.96-15.26,4.96c-4.44,0-8.35-1.04-11.72-3.13-3.38-2.09-5.99-5.06-7.82-8.91-1.84-3.85-2.79-8.32-2.87-13.41v-5.17c0-5.22.93-9.81,2.79-13.79,1.86-3.98,4.53-7.04,8.01-9.19s7.5-3.23,12.07-3.23c6.15,0,11.09,1.65,14.84,4.96s5.93,7.99,6.54,14.04h-9.64c-.46-3.98-1.62-6.85-3.5-8.61-1.87-1.76-4.62-2.64-8.24-2.64-4.21,0-7.44,1.53-9.7,4.58-2.26,3.06-3.41,7.54-3.46,13.44v4.91c0,5.98,1.08,10.55,3.23,13.69,2.15,3.14,5.31,4.71,9.47,4.71,3.8,0,6.66-.85,8.57-2.54,1.91-1.7,3.12-4.52,3.63-8.47h9.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m445.82,450.57h-9.68l-24.83-39.25v39.25h-9.68v-55.32h9.68l24.9,39.4v-39.4h9.6v55.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m496.39,403h-17.37v47.57h-9.6v-47.57h-17.21v-7.75h44.18v7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m524.16,429.29h-10.79v21.28h-9.68v-55.32h19.59c6.43,0,11.39,1.43,14.88,4.3,3.49,2.86,5.24,7.01,5.24,12.44,0,3.7-.9,6.8-2.7,9.3s-4.3,4.42-7.52,5.76l12.51,23.04v.49h-10.37l-11.17-21.28h.01Zm-10.79-7.75h9.95c3.26,0,5.81-.82,7.65-2.45s2.75-3.87,2.75-6.71-.85-5.26-2.54-6.88c-1.7-1.62-4.23-2.46-7.59-2.51h-10.21v18.54h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m616.35,442.89h25.29v7.67h-34.96v-55.31h9.68v47.64h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m73.92,432.56c-.56,5.9-2.75,10.51-6.58,13.81s-8.91,4.96-15.26,4.96c-4.44,0-8.35-1.04-11.72-3.13-3.38-2.09-5.99-5.06-7.82-8.91-1.84-3.85-2.79-8.32-2.87-13.41v-5.17c0-5.22.93-9.81,2.79-13.79s4.53-7.04,8.01-9.19,7.5-3.23,12.07-3.23c6.15,0,11.09,1.65,14.84,4.96s5.93,7.99,6.54,14.04h-9.64c-.46-3.98-1.63-6.85-3.5-8.61-1.87-1.76-4.62-2.64-8.24-2.64-4.21,0-7.44,1.53-9.7,4.58-2.26,3.06-3.41,7.54-3.46,13.44v4.91c0,5.98,1.08,10.55,3.23,13.69,2.15,3.14,5.31,4.71,9.47,4.71,3.8,0,6.66-.85,8.57-2.54s3.12-4.52,3.63-8.47h9.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m92.24,442.89h25.29v7.67h-34.96v-55.31h9.68v47.64h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m217.33,395.25v36.96c0,5.88-1.89,10.53-5.68,13.96s-8.83,5.15-15.13,5.15-11.44-1.69-15.19-5.07c-3.75-3.38-5.62-8.07-5.62-14.08v-36.92h9.64v37c0,3.7.94,6.52,2.83,8.47s4.67,2.93,8.34,2.93c7.45,0,11.17-3.9,11.17-11.7v-36.7h9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m227.66,450.57v-55.32h16.45c4.92,0,9.29,1.09,13.1,3.27,3.81,2.18,6.76,5.27,8.86,9.27,2.09,4,3.14,8.59,3.14,13.75v2.77c0,5.24-1.05,9.85-3.16,13.83s-5.1,7.04-8.99,9.19-8.35,3.23-13.37,3.23h-16.03Zm9.68-47.57v39.89h6.31c5.07,0,8.97-1.58,11.69-4.73,2.72-3.15,4.1-7.68,4.15-13.58v-3.08c0-6-1.31-10.59-3.94-13.75-2.63-3.17-6.44-4.75-11.44-4.75h-6.77,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Uova_per_scritta",
    "data-name": "Uova per scritta"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2_copia_2",
    "data-name": "2 copia 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m560.05,448.79c7.71,5.31,15.87,4.46,17.72,4.22,2.82-.36,9.63-1.72,15.04-7.5,4.55-4.86,5.61-10.3,6.09-12.87,1.67-8.9-1.42-16.05-3.35-20.49-1.03-2.39-3.64-7.84-8.92-13.29-5.03-5.2-9.15-9.46-14.59-9.23-5.99.24-10.16,5.79-13.93,10.81-.93,1.24-4.47,6.1-6.72,13.75-1.62,5.52-3.81,12.96-.91,21.47.77,2.26,3,8.63,9.55,13.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m589.38,401.95c-3-1.3-7.38-2.76-12.81-3.18-9.01-.7-16.08,1.85-19.71,3.47l1.68-2.36c2.99-1.46,9.44-4.09,17.73-3.32,4.78.45,8.57,1.87,11.1,3.08l2.01,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m595.76,412.7c-5.95-2.12-11.09-3.07-14.77-3.55-5.93-.76-11.52-1.48-18.22.43-5.43,1.55-9.38,4.19-11.76,6.07.31-1.05.61-2.1.92-3.15,2.08-1.52,5.54-3.69,10.23-5.07,7.19-2.11,13.31-1.19,19.32-.28,3.27.49,7.91,1.43,13.34,3.38.31.72.62,1.44.94,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m598.88,422.72c-4.38-2.07-19.12-8.34-35.76-2.97-6.09,1.97-10.77,4.96-14.05,7.55.03-.91.06-1.82.1-2.74,3.23-2.47,7.68-5.23,13.38-7.09,16.53-5.42,31.28.62,35.88,2.73.15.84.3,1.68.45,2.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 555.7,
    cy: 416.21,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 563.87,
    cy: 412.47,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 593.65,
    cy: 415.47,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 583.98,
    cy: 413,
    r: 1.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 574.39,
    cy: 411.57,
    r: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m596.6,439.99c-5.43,2.94-17.68,8.51-32.49,5.94-3.78-.66-7.11-1.74-9.94-2.93-.5-.79-1-1.58-1.5-2.37,3.33,1.22,7.28,2.3,11.77,2.87,14.92,1.91,27.05-2.92,33.19-5.96-.34.82-.69,1.63-1.03,2.45Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_3_copia_2",
    "data-name": "3 copia 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m363,449.46c8.78,2.63,16.14-.6,17.8-1.38,2.52-1.19,8.46-4.49,11.78-11.51,2.78-5.89,2.14-11.29,1.82-13.82-1.11-8.8-6.14-14.53-9.27-18.11-1.68-1.92-5.75-6.22-12.3-9.72-6.25-3.34-11.37-6.07-16.37-4.23-5.51,2.03-7.74,8.45-9.75,14.26-.5,1.43-2.34,7.03-2.14,14.84.15,5.63.34,13.23,5.6,20.29,1.39,1.87,5.39,7.15,12.85,9.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deco-2",
    "data-name": "deco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m376.29,396.99c-5.35,3.17-12.57,6.58-21.51,8.6-3.09.7-6.01,1.15-8.73,1.42l.86-2.7c2.67-.19,5.64-.6,8.83-1.34,7.69-1.78,13.73-4.86,17.98-7.54l2.57,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m386.46,406.2c-3.11-1.11-7.22-1.99-10.03.01-3.14,2.24-1.73,6-4.91,8.47-3.97,3.08-8.36-1.09-13.13,2.04-3.44,2.26-2.98,5.65-6.29,6.86-2.66.98-5.55-.26-7.45-1.34-.03-.82-.07-1.64-.1-2.45,1.86,1.3,4.56,2.72,7,1.9,3.03-1.02,2.55-4.43,5.81-6.64,4.52-3.07,8.98,1.12,12.9-1.88,3.03-2.32,1.69-5.81,4.77-8.17,2.79-2.14,6.83-1.52,9.7-.74.58.65,1.15,1.29,1.73,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m391.28,413.09c-4.12-1.53-9.06-2.59-12.16-.19-3.06,2.36-1.7,5.98-4.91,8.47-3.97,3.08-8.36-1.09-13.13,2.04-3.47,2.28-2.94,5.35-6.29,6.86-3.11,1.41-6.75.14-9.43-1.22-.12-.72-.24-1.44-.35-2.16,2.71,1.49,6.28,2.84,9.23,1.48,3.13-1.44,2.56-4.44,5.81-6.64,4.52-3.07,8.98,1.12,12.9-1.88,3.09-2.36,1.81-5.73,4.77-8.17,2.9-2.39,7.59-1.93,12.56-.32.33.57.66,1.15.99,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m394.69,427.13c-1.94,2.18-5.05,4.94-9.33,5.71-5.99,1.08-9.47-2.57-13.43-.35-3.77,2.11-2.76,6.62-6.25,7.69-3.37,1.04-5.98-2.63-9.11-1.37-2.04.83-3,3.23-3.49,5.05-.47-.62-.93-1.25-1.4-1.87.71-1.99,1.99-4.52,4.3-5.25,3.36-1.05,5.85,2.69,9.01,1.66,3.33-1.08,2.18-5.77,5.77-7.94,3.93-2.38,7.81,1.72,13.98.56,3.1-.58,6.48-2.43,9.83-6.69.04.93.08,1.86.12,2.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_1_copia_4",
    "data-name": "1 copia 4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m122.27,439.99c4.64,8.27,12.43,11.14,14.23,11.76,2.73.93,9.52,2.74,17.03-.1,6.3-2.38,9.7-6.86,11.28-8.98,5.49-7.34,5.87-15.22,6.11-20.12.13-2.63.19-8.75-2.17-16.06-2.25-6.97-4.1-12.68-9.14-14.91-5.56-2.45-11.82.73-17.49,3.6-1.4.71-6.79,3.55-12.25,9.5-3.94,4.29-9.25,10.08-10.41,19.11-.31,2.39-1.13,9.18,2.81,16.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deco-3",
    "data-name": "deco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.91,418.37c-6.33.1-18.97-.68-30.82-8.89-3.26-2.26-5.92-4.7-8.05-7.03l1.43-1.32c2.07,2.26,4.68,4.66,7.91,6.87,11.37,7.76,23.46,8.34,29.37,8.18.05.73.11,1.46.16,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.58,409.43c-5,.24-15.72-.03-25.36-7-2.28-1.65-4.16-3.43-5.7-5.15.59-.38,1.17-.76,1.76-1.14,1.36,1.51,2.98,3.04,4.91,4.48,8.93,6.66,18.98,7.16,23.92,7.02.15.6.31,1.19.46,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m121.97,439.43c2.86,2.16,6.45,4.5,10.8,6.58,7.86,3.76,15.11,5.22,20.33,5.81.93-.41,1.86-.82,2.78-1.23-6.19-.97-14.19-2.91-22.84-6.96-4.83-2.26-8.94-4.74-12.36-7.11.43.97.86,1.94,1.29,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.43,433.2c-8.98-.59-22.49-2.82-36.28-10.86-4.2-2.45-7.81-5.07-10.89-7.65.4-.67.8-1.33,1.2-2,2.16,1.96,5.42,4.67,9.76,7.35,9.86,6.09,18.96,8.14,24.04,9.23,3.5.75,7.77,1.45,12.7,1.77-.18.72-.36,1.43-.53,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m164.64,442.88c-8.21,2.29-12.64.89-15.18-.9-4.34-3.06-4.54-8.19-8.8-9.08-3.79-.8-5.85,2.8-8.81,1.48-3.2-1.42-2.37-6.31-5.56-7.81-2.24-1.05-5.07.23-7.12,1.48.02-.69.03-1.38.05-2.07,3.93-2.25,6.37-2.27,7.94-1.47,3.16,1.61,2.36,6.29,5.57,7.69,2.8,1.22,4.56-1.82,8.1-1.16,4.5.84,4.83,6.34,9.28,9.39,2.56,1.76,7.16,3.17,15.98.33-.49.7-.97,1.4-1.46,2.1Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCloudPasqua);
export default __webpack_public_path__ + "static/media/LoginCloudPasqua.d93d141ad587e538f334e6fc06bc7aee.svg";
export { ForwardRef as ReactComponent };